import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import DashboardSingleBookset from 'rebook/apps/dashboard/components/DashboardSingleBookset';
import DashboardSingleBooksetEmpty from 'rebook/apps/dashboard/components/DashboardSingleBooksetEmpty';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


class DashboardBooksetBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;

    this.state = {
      block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBooksetDetail();
  }

  fetchBooksetDetail() {
    const { block, blockId } = this.state;
    const { dashboardBlockList } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    // fix for earlier version of dashboard
    const url = fixQueryString(block.resource_uri, { booklimit: 0 });
    this.props.DashboardBlockListActions.fetchDashboardBlock(url, { apiVersion: 3 })
      .then(
        ({ data, dispatch }) => {
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                bookset: data,
                books: data.books,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard bookset due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;

    return (
      get(dashboardBlockList[blockId], 'bookset', null)
        ? (
          <DashboardSingleBookset
            bookset={dashboardBlockList[blockId].bookset}
            blockTitle={this.state.block.title}
            halfWidth={this.props.halfWidth} />
        )
        : <DashboardSingleBooksetEmpty />
    );
  };
};

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardBooksetBlock.propTypes = {
  block: PropTypes.shape({
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBooksetBlock);
